import React, { PureComponent } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
import Error from '../component/ErrorDispaly.js';
import LoadingSpinner from '../component/LoadingSpinner';
import SecureShow from '../component/SecureShow';
import TableRow from '../component/TableRow';
import styles from '../css/styles.css.js';
import HelpText from '../lib/help-text';
import ReactTooltip from 'react-tooltip';
import { AppSetting, AppProperties } from '../common/function';
import SFMessage from './AssignmentMatrix/components/SFMessage.jsx';



let section = {
  section_name: '',
  enable_subsection:false,
  section_id: '',
  course_id: ''
};
export default class Sections extends PureComponent {
  helpTextModel = new HelpText();
  AppSetting = AppSetting();
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;
  constructor(props) {
    super(props);
    this.state = {
      sections: [],
      temp_section: section,
      temp_id: '',
      addMode: true,
      visible: false,
      course_id: this.props.location.query.course_id,
      course_name: this.props.location.query.course_name,
      is_lti_enabled: this.props.location.query.is_lti_enabled,
      semester_id: this.props.location.query.semester_id,
      semester_name: this.props.location.query.semester_name,
      is_current_semester: this.props.location.query.is_current_semester === "true",
      is_new: this.props.location.query.is_new ? this.props.location.query.is_new : false,
      errorMessage: '',
      errorType: '',
      loading:false,
      hasAddSectionAccess: false,
      courseData: null
    };
    this.isEnterPressed = this.isEnterPressed.bind(this);        
    this.deleteSection = this.deleteSection.bind(this);
    this.addSection = this.addSection.bind(this);
    this.changeSectionName = this.changeSectionName.bind(this);
    this.updateSection = this.updateSection.bind(this);
    this.updateSectionResponseHandler = this.updateSectionResponseHandler.bind(
      this
    );
  }

  addBreadCrumbs = () => {
    console.debug('Sections AddBreadCrumbs');
    this.props.replaceBreadCrumb([
      {
        name:(this.appProperties.schoolMode?'All Standards':'All Courses') ,
        type: '',
        onclickPath: 'Courses'
      },
      {
        name: this.state.course_name,
        type: (this.appProperties.schoolMode?'Standards':'Courses'),
        onclickPath:
          'sections?course_id=' +
          this.state.course_id +
          '&course_name=' +
          this.state.course_name +
          '&is_lti_enabled=' +
          this.state.is_lti_enabled +
          '&semester_id=' +
          this.state.semester_id +
          '&semester_name=' +
          this.state.semester_name +
          '&is_current_semester=' +
          this.state.is_current_semester
      }
    ]);
    console.debug("this.state.semester_name>>??", this.state.semester_name)
  };

  componentWillUpdate() {
    this.addBreadCrumbs();
  }

  componentWillMount() {
    var cour_id = parseInt(this.state.course_id, 10);
    var semester_id = parseInt(this.state.semester_id, 10);
    const payload = {
      // course_id: this.state.course_id
      course_id: cour_id,
      semesterID: semester_id,
    };
    console.debug('Course id : ', payload);
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/getAllSections',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      console.debug(res);
      console.debug(res.data.data.section_names);
      if (res.data.data.section_names != null) {
        this.setState({
          sections: res.data.data.section_names
        });
      }
    });

    this.checkIfUserHasAccessToCreateSections();
  };

  componentDidMount() {
    // console.debug("this.state.is_new>>??", this.state.is_new);
    this.getCourseDetails();
  }

  getCourseDetails = () => {
    var cour_id = parseInt(this.state.course_id, 10);
    this.setState({
      loading: true,
    })
    ApiRequestService({
      method: 'post',
      url: '/getCourseDetail',
      data: {
        course_id: cour_id
      }
    }).then(res => {
      if (res && res.data && res.data.message) {
        NotificationManager.error(res.data.message, "", 3000);
        return;
      }
      if (res && res.data && res.data.data) {
        this.setState({
          courseData: res.data.data
        })
      }
    }).finally(() => {
      this.setState({
        loading: false,
      })
    })
  }

  componentWillUnmount() {
    this.removeBreadCrumbs();
  }

  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
  };


  addSection() {
    console.debug('Add section :' + this.state.temp_section.section_name);
    var sub_id = parseInt(this.state.course_id, 10);
    const payload = {
      section_name: this.state.temp_section.section_name,
      course_id: sub_id,
      enable_practice_and_performance: 2, // default to Practice & Analytics
    };
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/addSection',
      data: payload
    }).then(res => {
      this.setState({
        loading:false
      });
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }

      if (res.data.data != null) {
        var tempSectionArr = this.state.sections.slice();
        tempSectionArr.push({
          section_name: res.data.data.section_name,
          section_id: res.data.data.section_id,
          course_id: res.data.data.course_id,
          enable_practice_and_performance:res.data.data.enable_practice_and_performance,
        });
        this.setState({
          sections: tempSectionArr
        });
        NotificationManager.success("Section added Successfully", '', 2000);
        console.debug('Add  tempSectionArr : ', tempSectionArr);
      }
      this.hide();
    });
  }

  editSection(id) {
    this.setState({
      temp_section: this.state.sections[id],
      temp_id: id,
      addMode: false
    });

    this.show(false);
  }

  updateSectionResponseHandler(res) {
    try {
      NotificationManager.listNotify.forEach(n => NotificationManager.remove({ id: n.id }));  
    } catch (error) {
      console.debug("error", error)
    }
    
    this.setState({
      loading:false
    });
    console.debug(res);
    if (res.data.message !== null && res.data.message !== '') {
      NotificationManager.error(res.data.message, 'ERROR', 3000);
      return
    }
    if (res.data.data != null) {
      let tempSections = this.state.sections;
      tempSections[this.state.temp_id] = this.state.temp_section;
      this.setState({
        sections: tempSections,
        temp_section: section
      });
      NotificationManager.success("Updated Successfully", '', 2000);
    }
    this.hide();
  }

  enableSubSection = (id) => {

    this.setState({
      loading:false
    });
    let temp_data =  this.state.sections[id];
    temp_data.enable_subsection = temp_data.enable_subsection ? false : true;
    console.log('this.statetemp_data',temp_data)
    this.setState({ temp_section: temp_data,  temp_id: id, addMode: false });
    var sub_id = parseInt(this.state.course_id, 10);

    const payload = {
      section_name: temp_data.section_name,
      course_id: sub_id,
      section_id: temp_data.section_id,
      enable_subsection: temp_data.enable_subsection
    };
    console.log('payload',payload)
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/updateSection',
      data: payload
    }).then(this.updateSectionResponseHandler);

  }

  onChangeShowInHomePage = (index) => {
    let section = this.state.sections[index]; 
    if (!section) return;

    /* let newValue = !section.show_in_homepage;
    if (newValue === false) {
      NotificationManager.error("One section needs to be shown on the homepage.", "Required", 3000);
      return;
    } */

    let payload = {
      ...section,
      show_in_homepage: !section.show_in_homepage
    }
    this.setState({ loading: true });

    ApiRequestService({
      method: 'post',
      url: '/updateSectionHomePage',
      data: payload
    }).then(res => {
      if (res && res.data && res.data.message) {
        NotificationManager.error(res.data.message, "", 3000);
        return;
      }
      if (res && res.data && res.data.message === "") {
        let updatedSections = [...this.state.sections];
        for (let i = 0; i < updatedSections.length; i++) {
          if (i === index) {
              updatedSections[i].show_in_homepage = !updatedSections[i].show_in_homepage;
          }
        }
        this.setState({ sections: updatedSections });
        NotificationManager.success("Updated Successfully", '', 2000);
      }
    }).finally(() => {
      this.setState({ loading: false });
    })

  }

  enableDashboard = (id,value) => {
    this.setState({
      loading:false
    });
    let temp_data =  this.state.sections[id];
    temp_data.enable_practice_and_performance = value;
    this.setState({ temp_section: temp_data,  temp_id: id, addMode: false });
    var sub_id = parseInt(this.state.course_id, 10);

    const payload = {
      section_name: temp_data.section_name,
      course_id: sub_id,
      section_id: temp_data.section_id,
      enable_subsection: temp_data.enable_subsection,
      enable_practice_and_performance: value,
    };
    console.log('payload',payload)
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/updateSection',
      data: payload
    }).then(this.updateSectionResponseHandler)
    .finally(() => {
      this.setState({
        loading:false
      });
    });
  }

  updateSection() {

    //console.log('this.state.temp_data.enable_subsection',this.state.temp_section)
    var sub_id = parseInt(this.state.course_id, 10);

    console.debug('Editing section id:' + this.state.temp_section.section_id);
    console.debug(
      'Editing section name:' + this.state.temp_section.section_name
    );
    console.debug('Editing course id:' + sub_id);

    const payload = {
      section_name: this.state.temp_section.section_name,
      course_id: sub_id,
      section_id: this.state.temp_section.section_id,
      enable_subsection: this.state.temp_section.enable_subsection
    };
    this.setState({
      loading:true
    });
    ApiRequestService({
      method: 'post',
      url: '/updateSection',
      data: payload
    }).then(this.updateSectionResponseHandler);
  }
  deleteSection(id) {
    console.debug(
      'Deleting section i:' + id + ' id: ' + this.state.sections[id].section_id
    );
    var sub_id = parseInt(this.state.course_id, 10);
    const payload = {
      course_id: sub_id,
      section_id: this.state.sections[id].section_id
    };
    ApiRequestService({
      method: 'post',
      url: '/deleteSection',
      data: payload
    }).then(res => {
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 5000);
      }else{
        console.debug('delete section response', res);
        let sections = [...this.state.sections]
        sections.splice(id, 1)
        this.setState({
          sections: sections
        });
        console.debug('Spliced Array', this.state.sections);
    }
    });
  }

  changeSectionName(value) {

    let newSection = this.state.temp_section;
    newSection.section_name = value;
    this.setState({
      temp_section: newSection
    });
  }

  show = isSectionEnable => {
    if (isSectionEnable) {
      this.setState({
        temp_section: {
          section_name: '',
          section_id: '',
          course_id: '',
          enable_subsection: ''
        }
      });
    }

    this.setState({ visible: true });
  };

  hide = () => {

    this.setState({
      visible: false,
      addMode: true
    });
  };

  subjPage() {

    browserHistory.push(this.baseFolder + 'courses');
  }

  delete = id => {
    confirmAlert({
      title: 'Are you sure want to delete this Section?',
      message: 'Press Confirm to submit',

      confirmLabel: 'Cancel',
      cancelLabel: 'Confirm',
      onCancel: () => this.deleteSection(id)
      //   onCancel: () => dissmiss,
/*       customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>Are you sure want to delete this Section?</h1>
            <p>Press Confirm to submit</p>
            <button onClick={() => {
                this.handleClickDelete()
                onClose()
            }}>Confirm</button>
            <button onClick={onClose}>Cancel</button>
          </div>
        )
      } */
    });
  };


  isEnterPressed(event){

    var code = event.keyCode || event.which;
    if(code === 13) { //13 is the enter keycode
      if (this.state.addMode) {
        this.addSection();
      } else{
       this.updateSection();
      }
   }
  }

  checkIfUserHasAccessToCreateSections() {
    var courseID = parseInt(this.state.course_id, 10);

    ApiRequestService({
      method: 'post',
      url: '/checkAddSectionAccess',
      data: {
        course_id: courseID
      }
    }).then(res => {
      if (res && res.data && res.data.data) {
        this.setState({ hasAddSectionAccess: true })
      }
    });

  }

  render() {
   console.log('render',this.state.sections)

    let button = null;
    if (this.state.addMode) {
      button = (
        <Button style={styles.addButton} onClick={this.addSection}>
          Add Section
        </Button>
      );
    } else {
      button = (
        <Button style={styles.addButton} onClick={this.updateSection}>
          Update Section
        </Button>
      );
    }
    var cancelButton = (
      <Button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </Button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);

    var tbody = null;
    if (this.state.sections != null) {
      tbody = (
        <tbody>
          {this.state.sections.map((section, i) => (
            <TableRow
              key={i}
              data={section}
              pushId={'sections'}
              id={section.section_id}
              name={section.section_name}
              enable_subsection={section.enable_subsection}
              enable_subsection_title={'Enable Subsection'}
              EnablePracticeAndPerformance={section.enable_practice_and_performance}
              enable_dashboard_title={'Enable Dashboard'}
              title={'Sections'}
              type={''}
              url={
                section.enable_subsection ?
                'sectionTabs?section_id=' +
                section.section_id +
                '&course_id=' +
                this.state.course_id +
                '&course_name=' +
                this.state.course_name +
                '&is_lti_enabled=' +
                this.state.is_lti_enabled +
                '&section_name=' +
                section.section_name +
                '&semester_id=' +
                this.state.semester_id +
                '&semester_name=' +
                this.state.semester_name +
                '&is_current_semester=' +
                this.state.is_current_semester
                :
                'quizList?section_id=' +
                section.section_id +
                '&course_id=' +
                this.state.course_id +
                '&course_name=' +
                this.state.course_name +
                '&is_lti_enabled=' +
                this.state.is_lti_enabled +
                '&section_name=' +
                section.section_name +
                '&semester_id=' +
                this.state.semester_id +
                '&semester_name=' +
                this.state.semester_name +
                '&is_current_semester=' +
                this.state.is_current_semester
              }
              onEditClick={() => this.editSection(i)}
              onDeleteClick={() => this.delete(i)}
              onEnableSubsection={() => this.enableSubSection(i)}
              onChangeShowInHomePage={() => this.onChangeShowInHomePage(i)}
              onEnableDashboard={(value) => this.enableDashboard(i,value)}
              instructorSubject = {true}
              showHomepageColumn={
                this.state.courseData && this.state.courseData.is_special && 
                (this.appProperties?.currentUserData?.USER_NAME === "jith" || this.appProperties?.currentUserData?.USER_NAME === "heckler.6")
                ? true : false
              }
              disableActionButtons={this.state.is_current_semester === false}
            />
          ))}
        </tbody>
      );
    }

    return (
      (this.state.loading)?
         <LoadingSpinner loading={this.state.loading} />
      :
      <SecureShow targetRole={1}>
        <div>
          {/* <div onClick = {this.subjPage} style={subjPage}>Courses >  </div>
            <div onClick = {this.sectionPage} style={sectionPage}>Sections</div> */}

          <div style={{
            width:'95%',
            margin: '0 auto'
          }}>

            {/* Course information message */}
            {/* <div className='mb-2'>
               <SFMessage 
                  show={true}
                  type='info'
                  title="Course Information"
                  description={
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <div>
                        <strong>Course ID:</strong> {this.state.course_id}
                      </div>
                      <div>
                        <strong>Course Name:</strong> {this.state.course_name}
                      </div>
                    </div>
                  }
                />
            </div> */}

            {/* No section warning message */}
            <SFMessage 
              show={this.state.sections === null || this.state.sections === undefined || this.state.sections?.length === 0}
              type='warning'
              title={"No Sections Available"}
              description={"This course has no sections yet. Please create at least one section to begin adding assignments and enrolling students."}
            />
          </div>

          <div style={styles.sectionTitle}>
            {this.state.semester_name} | Sections under - {this.state.course_name}
            {this.state.hasAddSectionAccess ? (
            <div style={styles.floatRight}>
            <Button className="archive-button" primary raised
              disabled={this.state.is_current_semester === false}
              style={{float: "right"}}
                onClick={() => this.show(true)}>
                  Add a New Section
              </Button>
            </div>
          ) : (
                ''
        )}
          </div>

          <DialogContainer
            id="simple-action-dialog"
            visible={this.state.visible}
            onHide={this.hide}
            actions={actions}
            width="500px"
            //title="New Section"
          >
          <p style={{fontSize:"medium"}}><label for="secId">New Section</label></p>
            <TextField
              id="secId"
              type="text"
              name="section_name"
              defaultValue={this.state.temp_section.section_name || ''}
              onChange={this.changeSectionName}
              onKeyPress={this.isEnterPressed.bind(this)}
            />
          </DialogContainer>
          <table style={styles.sectionTable}>
            <thead style={styles.thead}>
              <tr>
                <th>ID</th>
                <th>Sections</th>
                <th>Created At</th>
                <th>Created By</th>
                <th>Enable Subsection
                  <Button className='nocqcStyle' icon data-tip data-for='enable-subsection'>help</Button>
                      <ReactTooltip id='enable-subsection' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Enable Subsection')}</span>
                      </ReactTooltip>
                </th>
                <th>Enable Assignment Practice
                  <Button className='nocqcStyle' icon data-tip data-for='enable-dashboard'>help</Button>
                      <ReactTooltip id='enable-dashboard' type='light' className='tool-tip'>
                        <span>{this.helpTextModel.getHelpTextForKey('Enable Assignment Practice')}</span>
                      </ReactTooltip>
                </th>
                {(
                  this.state.courseData && this.state.courseData.is_special && 
                  (this.appProperties?.currentUserData?.USER_NAME === "jith" || this.appProperties?.currentUserData?.USER_NAME === "heckler.6")
                ) ? 
                  <th>Show in Home Page
                    <Button className='nocqcStyle' icon data-tip data-for='show-in-homepage'>help</Button>
                        <ReactTooltip id='show-in-homepage' type='light' className='tool-tip'>
                          <span>
                            {this.helpTextModel.getHelpTextForKey('Show in Home Page')}
                          </span>
                        </ReactTooltip>
                  </th>
                : null}
                <th>Actions</th>
              </tr>
            </thead>

            {tbody}
          </table>
          <Error
            type={this.state.errorType}
            message={this.state.errorMessage}
          />
        </div>
      </SecureShow>
    );
  }
}
